import { FooterItemsConstant, HeaderItemsConstants } from "./misc";
import { mostSearchedLinksMenusKeys } from "./mostSearchedLinks";

interface EventMapTypes {
    [key: string]: number;
}

export const FooterItemsGaEvents: EventMapTypes = {
    [FooterItemsConstant.ABOUT_US]: 0,
    [FooterItemsConstant.CONTACT_US]: 1,
    [FooterItemsConstant.CAREERS]: 2,
    [FooterItemsConstant.FAQ]: 3,
    [FooterItemsConstant.TERMS_AND_CONDITION]: 4,
    [FooterItemsConstant.PAYMENT_GUIDELINES]: 5,
    [FooterItemsConstant.PRIVACY_POLICY]: 6,
    [FooterItemsConstant.CONNECT_WITH_US]: 7,
    [FooterItemsConstant.DOWNLOAD_OUR_APP]: 8,
    [FooterItemsConstant.CASHBACK_TERMS_AND_CONDITIONS]: 10
};

export const HeaderItemsGaEvents: EventMapTypes = {
    [HeaderItemsConstants.SERVICE_MENU]: 0,
    [HeaderItemsConstants.MARKETPLACE]: 1,
    [HeaderItemsConstants.TRANSPORT_DIRECTORY]: 2,
    [HeaderItemsConstants.RESOURCES_MENU]: 3,
    [HeaderItemsConstants.COMPANY_MENU]: 4,
    [HeaderItemsConstants.LOGIN]: 5
};

export const MostSearchedLinksItemsGaEvents: EventMapTypes = {
    [mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING]: 0,
    [mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING]: 1,
    [mostSearchedLinksMenusKeys.TRANSPORTER]: 2,
    [mostSearchedLinksMenusKeys.TRANSPORT_SERVICE]: 3,
    [mostSearchedLinksMenusKeys.TRANSPORT_DIRECTORY]: 4,
    [mostSearchedLinksMenusKeys.LORRY]: 5
};
